var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.663 6.545v3.099h4.393c-.192.996-.771 1.84-1.64 2.407l2.65 2.014c1.543-1.396 2.434-3.447 2.434-5.883a9.01 9.01 0 0 0-.149-1.637H8.663Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.088 9.523-.598.448-2.115 1.614A8.18 8.18 0 0 0 8.662 16c2.204 0 4.052-.713 5.403-1.934l-2.65-2.015c-.727.48-1.654.77-2.753.77-2.122 0-3.925-1.403-4.571-3.294l-.003-.004Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.376 4.415a7.773 7.773 0 0 0 0 7.17c0 .008 2.716-2.065 2.716-2.065-.163-.48-.26-.99-.26-1.52 0-.531.097-1.04.26-1.52L1.376 4.415Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.664 3.185c1.202 0 2.27.408 3.124 1.193l2.338-2.29C12.708.792 10.868 0 8.664 0a8.167 8.167 0 0 0-7.288 4.415L4.092 6.48c.646-1.89 2.45-3.295 4.572-3.295Z",
    fill: "#EA4335"
  })));
};
export default SvgGoogleIcon;